import React from 'react';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import CreateAccount from 'Dashboard/components/Onboarding/OnboardingWizard/MobileOnboardingWizard/CreateAccount/CreateAccount';
import OnboardingSlackTitle from './OnboardingSlackTitle';

// Styles
import './OnboardingSlackAICreateAccount.scss';

const OnboardingSlackAICreateAccount = () => {
  const { profile, cannotSignIntoGoogle, forceToDesktop, handleAdvanceBackOnboardingState } = useOnboardingState();

  const baseClassName = 'OnboardingSlackAICreateAccount';

  return (
    <div className={baseClassName}>
      <OnboardingSlackTitle onBack={handleAdvanceBackOnboardingState} title="" />
      <WpContainer className={`${baseClassName}__container`}>
        <WpContainerBody padding={32}>
          <CreateAccount
            profile={profile}
            includeNameField
            cannotSignIntoGoogle={cannotSignIntoGoogle}
            forceToDesktop={forceToDesktop}
            description={
              'Keep using AgendaAI - Customize AgendaAI’s responses and collaborate with your teammates in real time. Free to sign up — no credit card needed!'
            }
          />
        </WpContainerBody>
      </WpContainer>
    </div>
  );
};

export default OnboardingSlackAICreateAccount;
